/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';
import moment from 'moment';
import 'moment/locale/es-mx';
import { SnackbarProvider } from 'notistack';
import { CloProvider } from './contexts/cloContext';

moment.locale('es-mx')

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',  // Para que la notificación aparezca en la parte superior
        horizontal: 'right',  // Para que aparezca a la derecha
      }}
    >
      <CloProvider>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </CloProvider>
    </SnackbarProvider>
  );
}
